import React from 'react';

import { Box, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { ComponentInfo } from '@components';
import { rem } from '@helpers';
import { LogoBcp } from '@icons';

import { RequestToCallClose, RequestToCallOpen, RequestToCallWarning } from './block';
import { useRequestContactHelper } from './requestContact.helper';

export const RequestContactPlaceholder: React.FC = () => {
	const {
		resources,
		phone,
		isAgentOpen,
		showDisclaimer,
		indicative,
		validateClickToCallAgentOpen,
		setPhone,
		setIndicative,
		setContactToCallCountry,
		newRequestContact,
		hideDisclaimer,
	} = useRequestContactHelper();

	return (
		<ComponentInfo
			name="RequestContactPlaceholder"
			type="placeholder"
			as={Box}
			styles={{
				flexDirection: 'column',
				minHeight: '100vh',
				alignItems: 'center',
				justifyContent: 'space-around;',
			}}
		>
			<Box
				styles={{
					justifyContent: 'start',
					marginTop: rem(60),
				}}
			>
				<LogoBcp />
			</Box>

			{isAgentOpen === 'Open' && (
				<RequestToCallOpen
					phone={phone}
					indicative={indicative}
					validateClickToCallAgentOpen={validateClickToCallAgentOpen}
					setPhone={setPhone}
					setIndicative={setIndicative}
					setContactToCallCountry={setContactToCallCountry}
				/>
			)}
			{isAgentOpen === 'Closed' && <RequestToCallClose hideDisclaimer={hideDisclaimer} />}

			{isAgentOpen === 'ErrorToCall' && (
				<RequestToCallWarning
					newRequestContact={newRequestContact}
					tryAgainButton={validateClickToCallAgentOpen}
				/>
			)}
			<Box
				styles={{
					width: rem(704),
					justifyContent: 'center',
					textAlign: 'center',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Box>
					{showDisclaimer && (
						<Typography appearance="microcopy-75-02" colorToken="interaction-01-100">
							{resources.disclaimer}
						</Typography>
					)}
				</Box>
			</Box>
		</ComponentInfo>
	);
};
